<!-- <div class="modal-dialog"> -->
<div class="modal-content">
  <div class="modal-header">
    <div class="col-10" class="text-left">
      <label style="font-weight:normal; font-size: 12px;">{{ 'LABELS.ENTER_CHEQUE_INFORMATION' | translate}}</label>
    </div>
    <div class="col-2" class="text-right">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
    </div>
  </div>
  <div class="modal-body">
    <!-- <div class="grid-structure"> -->
    <form #chequeDetailsForm="ngForm">
      <!-- <div class="chqheader">
          <label style="font-weight:normal; font-size: 12px;">{{ 'LABELS.ENTER_CHEQUE_INFORMATION' | translate}}</label>
        </div> -->
      <!-- <div class="row">
        <div class="col-12"> -->
          <!-- <div> -->
          <div class="row">
            <div class="col-12">
              <div class="form-group mb-3">
                <input  class="form-control" type="tel" pattern="[0-9]{6,6}$" appNumberOnly
                  placeholder="Cheque Number*" [(ngModel)]="chequeDetails.chequeNumber" clearInput required
                  name="chequeNumber" minlength="6" maxlength="6">
              </div>
            </div>
          </div>
          <!-- </div> -->
        <!-- </div>
      </div> -->
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-3">
          <!-- <div> -->
            <input class="form-control" type="tel" pattern="[0-9]*" appNumberOnly numericType="decimal"
              placeholder="Cheque Amount*" [(ngModel)]="chequeDetails.chequeAmount" clearInput required
              name="chequeAmount" max="999999999">
              </div>
          <!-- </div> -->
        </div>
      </div>
      <div class="row">
        <div class="col-12">
            <div class="form-group mb-3">
              <div class="input-group">
                <input class="form-control"  placeholder="Check Date" displayFormat="DD-MMM-YYYY" name="chqDate"
                  id="chqDate" [(ngModel)]="chequeDetails.chqDate" ngbDatepicker #td="ngbDatepicker"
                  #chqDate="ngModel" autocomplete="off" placement="bottom-right" required (click)="td.toggle()"
                  [maxDate]="maxDate" (ngModelChange)="chequeDateSelected()">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" #btnCalendar (click)="td.toggle()" type="button">
                    <i class="mdi mdi-calendar ms-1"></i>
                  </button>
                </div>
              </div>
           </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <!-- <div> -->
            <div class="form-group mb-3">
            <input class="form-control" type="text" placeholder="Bank Name*" [(ngModel)]="chequeDetails.bankName"
              clearInput required name="bankName">
            </div>
          <!-- </div> -->
        </div>
      </div>
      <div class="row button-list">
        <div class="col-12">
          <button class="btn fis-btn waves-effect" (click)="close()" data-dismiss="modal" type="button">{{ 'LABELS.CANCEL' |
            translate}}
          </button>
          <button class="btn btn-info waves-effect" appActionButton [disabled]="!chequeDetailsForm.form.valid" appThrottleClick
            (throttleClick)="submitCheque()" [throttleTime]="700">
            {{ 'LABELS.SUBMIT' | translate}}
          </button>
        </div>
      </div>
    </form>
    <!-- </div> -->
  </div>
</div>

<!-- </div> -->
